function TrackYourStatus(){
    return(
        <div className="form-body">
            <h2 className="heading2 form-heading">Track Your Status</h2>
            <div className="form-content">
            <div className="row">
                <div className="col-md-6">
                    <div className="form-top-search"><input type="text" placeholder="Pan Number/Refrence Number" /><button><i class="fas fa-search"></i></button></div>
                </div>                
            </div> 
            <div className="row">
                <div className="col-md-12 status-box">
                    <ul>
                        <li>
                            <label>Status</label>
                            <span>Pending</span>
                        </li>
                        <li>
                            <label>Refrence Number </label>
                            <span>2516</span>
                        </li>
                        <li>
                            <label>Pan Number </label>
                            <span>AODKP5454</span>
                        </li>
                        <li>
                            <label>Company Name Number </label>
                            <span>Cyfuture</span>
                        </li>
                        
                    </ul>
                </div>
            </div>
            </div>
        </div>
    )
}export default TrackYourStatus;